<template>
  <div class="commandPage">
    <el-table v-if="tabPaneData.product && (tabPaneData.product.productType.code=='AI_PC' || tabPaneData.product.productType.code=='AI_SERVER')" stripe border style="width: 100%" height="100%" size="mini" @sort-change="sortChange"
      :data="tableData">
      <el-table-column type="index" align="center"
        :width="pagination.endIndex >= 1000 ? 80 : 50"
        :index="pagination.beginIndex"></el-table-column>
      <el-table-column prop="deviceId" label="SN" align="center" min-width="120" sortable="custom">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.device" class="item" effect="dark" :content="scope.row.device.sn" placement="top" min-width="110px" :open-delay="300">
            <div class="textOverflow allowSkip" @click="clickAllowSkip(scope.row)">{{ scope.row.device.sn }}</div>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
<!--
      <el-table-column prop="deviceId" label="客户SN" align="center" min-width="120" sortable="custom">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.device && scope.row.device.attachSn" class="item" effect="dark" :content="scope.row.device.attachSn" placement="top" min-width="110px" :open-delay="300">
            <div v-if="scope.row.device.sn" class="textOverflow">{{ scope.row.device.attachSn ? scope.row.device.attachSn : "-" }}</div>
            <div v-else class="textOverflow allowSkip" @click="clickAllowSkip(scope.row)">{{ scope.row.device.attachSn ? scope.row.device.attachSn : "-" }}</div>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
-->
      <el-table-column prop="orgWorkstation" label="送修前工序" align="center" min-width="110" sortable="custom">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.orgWorkstation" class="item" effect="dark" :content="scope.row.orgWorkstation.code" placement="top" min-width="110px" :open-delay="300">
            <div class="textOverflow">{{ scope.row.orgWorkstation.name }}</div>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="errorCode1" label="不良现象" align="center" min-width="110" sortable="custom">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.errorCode1" class="item" effect="dark" :content="scope.row.errorCode1.code" placement="top" min-width="110px" :open-delay="300">
            <div class="textOverflow">{{ scope.row.errorCode1.name }}</div>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="errorCode2" label="不良原因" align="center" min-width="100px" sortable="custom">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.errorCode2" class="item" effect="dark" :content="scope.row.errorCode2.code" placement="top" min-width="110px" :open-delay="300">
            <div class="textOverflow">{{ scope.row.errorCode2.name }}</div>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="errorCode3" label="权责" align="center" min-width="150px" sortable="custom">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.errorCode3" class="item" effect="dark" :content="scope.row.errorCode3.code" placement="top" min-width="110px" :open-delay="300">
            <div class="textOverflow">{{ scope.row.errorCode3.name }}</div>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="errorCode4" label="维修方式" align="center" min-width="100px" sortable="custom" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.errorCode4">{{ scope.row.errorCode4}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="维修状态" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status">{{ scope.row.status.title}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="createUserId" label="送修人" align="center" show-overflow-tooltip min-width="100px">
        <template slot-scope="scope">
          <span v-if="scope.row.createUser">{{ scope.row.createUser.name }} ({{scope.row.createUser.employeeNum}})</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="createDateTime" label="送修时间" align="center" min-width="110px" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.createDateTime">{{ scope.row.createDateTime }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="lastUpdateUserId" label="维修人" align="center" min-width="100px" show-overflow-tooltip>
        <template slot-scope="scope">
         <span v-if="scope.row.repairUser">{{ scope.row.repairUser.name }} ({{scope.row.repairUser.employeeNum}})</span>
        </template>
      </el-table-column>
      <el-table-column prop="lastUpdateDateTime" label="维修时间" align="center" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.repairDateTime">{{ scope.row.repairDateTime }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-else stripe border style="width: 100%" height="100%" size="mini" @sort-change="sortChange"
      :data="tableData">
      <el-table-column type="index" align="center"
        :width="pagination.endIndex >= 1000 ? 80 : 50"
        :index="pagination.beginIndex"></el-table-column>
      <el-table-column prop="sn" label="SN" align="center" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.sn" class="allowSkip" @click="clickAllowSkip(scope.row)">{{ scope.row.sn }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="problem" label="故障现象" align="center" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.problemResultCode">{{ scope.row.problemResultCode.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="repairContent" label="故障类别" align="center" min-width="100px" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.resultCategory">{{ scope.row.resultCategory.name}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="problemReason" label="故障原因" align="center" min-width="150px" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.problemReason">{{scope.row.problemReason.name}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="materiaLocation" label="物料位置" align="center" min-width="100px" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.materialLocation">{{ scope.row.materialLocation}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="repairContent" label="维修方式" align="center" min-width="120px" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.repairResultCode">{{ scope.row.repairResultCode.name}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="维修状态" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status.title">{{ scope.row.status.title}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="result" label="维修结果" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.result">{{ scope.row.result.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="problemDes" label="备注" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.problemDes">{{ scope.row.problemDes }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="user" label="送修人" align="center" show-overflow-tooltip min-width="100px">
        <template slot-scope="scope">
          <span v-if="scope.row.user">{{ scope.row.user.name }} ({{scope.row.user.employeeNum}})</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="createDateTime" label="送修时间" align="center" min-width="110px" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.startDateTime">{{ scope.row.startDateTime }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="repairUser" label="维修人" align="center" min-width="100px" show-overflow-tooltip>
        <template slot-scope="scope">
         <span v-if="scope.row.repairUser">{{ scope.row.repairUser.name }} ({{scope.row.repairUser.employeeNum}})</span>
        </template>
      </el-table-column>
      <el-table-column prop="repairDateTime" label="维修时间" align="center" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.repairDateTime">{{ scope.row.repairDateTime }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :pagination="pagination" @currentChange="currentChange" @sizeChange="sizeChange" @refreshBtn="getRepairSearch"></pagination>

    <el-dialog title="维修记录详情" :visible.sync="dialogVisible" width="800px" @close="dialogClose"
      :close-on-click-modal="false" :close-on-press-escape="false" top="50vh" class="myDialog detailDialog" v-dialogDrag>
      <ul v-if="tabPaneData.product && (tabPaneData.product.productType.code=='AI_PC' || tabPaneData.product.productType.code=='AI_SERVER')" class="ulBox clearFloat">
        <li>
          <div class="left">SN：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.device">{{repairDetailData.device.sn}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">维修状态：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.status">{{repairDetailData.status.title}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">不良现象：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.errorCode1">{{repairDetailData.errorCode1.name}} ({{repairDetailData.errorCode1.code}})</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">不良原因：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.errorCode2">{{repairDetailData.errorCode2.name}} ({{repairDetailData.errorCode2.code}})</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">权责：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.errorCode3">{{repairDetailData.errorCode3.name}} ({{repairDetailData.errorCode3.code}})</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">维修方式：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.errorCode4">{{repairDetailData.errorCode4}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">送修人：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.createUser">{{ repairDetailData.createUser.name }} ({{repairDetailData.createUser.employeeNum}})</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">送修时间：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.createDateTime">{{repairDetailData.createDateTime}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">维修人：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.repairUser">{{ repairDetailData.repairUser.name }} ({{repairDetailData.repairUser.employeeNum}})</span>
             <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">维修时间：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.repairDateTime">{{repairDetailData.repairDateTime}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
      </ul>
      <ul v-else class="ulBox clearFloat">
        <li>
          <div class="left">SN：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.sn">{{repairDetailData.sn}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">故障现象：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.problemResultCode">{{repairDetailData.problemResultCode.name}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">故障类别：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.resultCategory">{{repairDetailData.resultCategory.name}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">故障原因：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.problemReason">{{repairDetailData.problemReason.name}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">物料位置：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.materialLocation">{{repairDetailData.materialLocation}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">物料规格：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.materialSpecification">{{repairDetailData.materialSpecification}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">维修方式：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.repairResultCode">{{repairDetailData.repairResultCode.name}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li class="blockLi">
          <div class="left">备注：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.problemDes">{{repairDetailData.problemDes}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">维修状态：</div>
          <div class="right">
            <span v-if="repairDetailData.status">{{ repairDetailData.status.title }}</span>
            <span v-else>-</span>
          </div>
        </li>
        <li class="blockLi">
          <div class="left">维修结果：</div>
            <div class="right">
              <span class="value" v-if="repairDetailData.result">{{repairDetailData.result.title}}</span>
              <span class="noValue" v-else>-</span>
            </div>
        </li>
        <li>
          <div class="left">送修人：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.user">{{ repairDetailData.user.name }} ({{repairDetailData.user.employeeNum}})</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">送修时间：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.startDateTime">{{repairDetailData.startDateTime}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">维修人：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.repairUser">{{ repairDetailData.repairUser.name }} ({{repairDetailData.repairUser.employeeNum}})</span>
             <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">维修时间：</div>
          <div class="right">
            <span class="value" v-if="repairDetailData.repairDateTime">{{repairDetailData.repairDateTime}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="tabPaneData.product && (tabPaneData.product.productType.code=='AI_PC' || tabPaneData.product.productType.code=='AI_SERVER') && (repairDetailData.status && (repairDetailData.status.code=='WAIT' || repairDetailData.status.code=='WAIT_REPAIR'))" class="ulBox clearFloat"
          size="small" @click="rollback(repairDetailData.id)">退回送修前</el-button>
        <el-button type="primary" size="small" @click="closeDetail">关闭</el-button>
      </div>
    </el-dialog>    
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import {apiAipcRepairSearch, apiAipcRepairRecordExport,apiAipcRepairRollback} from "@/api/aipcRepair.js";
import { apiRepairSearch ,apiRepairDetail,apiRepairRecordExport} from "@/api/repair.js";
export default {
  components: {
    pagination,
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    tabPaneData: {
      type: Object,
    },
    RepairRecordForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      dialogVisible: false,
      repairDetailData: {},
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
    };
  },
  methods: {
    rollback(id) {
      this.$confirm(`确定要将此产品退回到送修前的状态吗？`, `退回送修前`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          const res = await apiAipcRepairRollback({
            id
          });
          if (res.code == 0) {
            this.closeDetail();
            this.getRepairSearch();
          }   
        });
    },
    closeDetail() {
        this.dialogVisible = false;
    },
    // 表格列命令名称点击
    async clickAllowSkip(row) {
      if (this.tabPaneData.product.productType.code=='AI_PC' || this.tabPaneData.product.productType.code=='AI_SERVER') {    
          this.dialogVisible = true;
          this.repairDetailData = row;
      } else {
        const res = await apiRepairDetail({
          id: row.id,
        });
        if (res.code == 0) {
          this.dialogVisible = true;
          this.repairDetailData = res.data;
        }
      }
    },
    dialogClose() {
      document.querySelectorAll(".el-dialog").forEach((item) => {
        setTimeout(() => {
          item.style.left = "0";
          item.style.top = "0";
        }, 500);
      });
    },
    // 表格数据
    async getRepairSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      if (this.tabPaneData.product.productType.code=='AI_PC' || this.tabPaneData.product.productType.code=='AI_SERVER') {
        const res = await apiAipcRepairSearch({
          productionOrderId: this.tabPaneValue,
          ...this.RepairRecordForm,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy,
        });
        if (res.code == 0) {
          this.tableData = res.data;
          this.pagination.total = res.total;
          this.pagination.beginIndex = res.beginIndex;
          this.pagination.endIndex = res.endIndex;
          if (callback) callback();
        }
      } else {
        const res = await apiRepairSearch({
          productionOrderId: this.tabPaneValue,
          ...this.RepairRecordForm,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy,
        });
        if (res.code == 0) {
          this.tableData = res.data;
          this.pagination.total = res.total;
          this.pagination.beginIndex = res.beginIndex;
          this.pagination.endIndex = res.endIndex;
          if (callback) callback();
        }
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getRepairSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getRepairSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getRepairSearch();
    },

    RepairRecordExport() {
      this.$confirm(`请勿频繁导出,确定导出按确定按钮`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        if (this.tabPaneData.product.productType.code=='AI_PC' || this.tabPaneData.product.productType.code=='AI_SERVER') {
          const res = await apiAipcRepairRecordExport({
            productionOrderId: this.tabPaneValue,
            ...this.RepairRecordForm,
            export: true,
          });
          if (res.code == 0) {
            this.$downloadFile(res.fid, res.fileName, res.secretKey);
          }        
        } else {
          const res = await apiRepairRecordExport({
            productionOrderId: this.tabPaneValue,
            ...this.RepairRecordForm,
            export: true,
          });
          if (res.code == 0) {
            this.$downloadFile(res.fid, res.fileName, res.secretKey);
          }
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.commandPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/deep/.detailTextArea textarea {
    border: 0;
    cursor: auto;
    padding: 3px 0;
  }
</style>